<template>
  <div class="container P-5 mt-5 mb-5">
    <h1>เกี่ยวกับเรา</h1>
<hr>
    <h3>โครงการการพัฒนานโยบายด้านการค้าการลงทุนรูปแบบใหม่เพื่อสนับสนุนและส่งเสริมการค้าและการลงทุนในเขตเศรษฐกิจระหว่างไทย-จีน</h3>
    <p>
แพลตฟอร์มนี้มีเป้าหมายที่จะเป็นศูนย์กลางในการสร้างความเข้าใจและส่งเสริมการค้าและการลงทุนในเขตเศรษฐกิจระหว่างไทยและจีน โดยสร้างความร่วมมือที่ยั่งยืนและตอบสนองต่อความต้องการของตลาดอย่างมีประสิทธิภาพ เป็นพื้นที่ที่มุ่งเน้นการวิจัยและการสนับสนุนนโยบายด้านการค้าและการลงทุนระหว่างประเทศไทยและสาธารณรัฐประชาชนจีน โดยมีเป้าหมายในการสร้างสภาพแวดล้อมทางเศรษฐกิจที่เอื้อต่อการลงทุนและการพัฒนาธุรกิจในพื้นที่เขตเศรษฐกิจพิเศษภาคตะวันออกเฉียงเหนือ เพื่อเพิ่มศักยภาพการแข่งขันและการสร้างความร่วมมือระหว่างนักลงทุนและผู้ประกอบการในทั้งสองประเทศ โดยโครงการวิจัยการพัฒนานโยบายด้านการค้าการลงทุนรูปแบบใหม่เพื่อสนับสนุนและส่งเสริมการค้าและการลงทุนในพื้นที่ระเบียงเศรษฐกิจระหว่างไทย-จีน ได้รับงบประมาณจากสำนักงานสภานโยบายการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรมแห่งชาติ (สอวช.) โดยหน่วยบริหารและจัดการทุนด้านการพัฒนาระดับพื้นที่ (บพท.) ในการพัฒนาแพลตฟอร์มนี้
</p>
  <h3>วิสัยทัศน์</h3>
  <p>สร้างความร่วมมือด้านการค้าและการลงทุนที่ยั่งยืนระหว่างไทยและจีน เพื่อเสริมสร้างเศรษฐกิจที่เข้มแข็งและขยายโอกาสทางธุรกิจสำหรับผู้ประกอบการทุกรูปแบบ</p>



<h3>พันธกิจ</h3>
<ul>
<li>พัฒนาและส่งเสริมแนวทางนโยบายที่เหมาะสม เพื่อสนับสนุนการค้าและการลงทุนในเขตเศรษฐกิจระหว่างไทยและจีน โดยอิงจากข้อมูลและการวิเคราะห์เชิงลึก</li>
<li>สร้างแพลตฟอร์มการแลกเปลี่ยนข้อมูลและทรัพยากร ที่เป็นศูนย์กลางสำหรับนักลงทุนและผู้ประกอบการในทั้งสองประเทศ เพื่อเพิ่มโอกาสในการทำธุรกิจ</li>
<li>สนับสนุน SMEs ในการเข้าถึงข้อมูลและทรัพยากรที่จำเป็นสำหรับการขยายธุรกิจและการแข่งขันในตลาดระหว่างประเทศ</li>
<li>สร้างความสัมพันธ์ที่ยั่งยืน ระหว่างผู้มีส่วนได้ส่วนเสียทั้งในไทยและจีน โดยจัดกิจกรรมเชื่อมโยงธุรกิจและการอบรม</li>
<li>ส่งเสริมการพัฒนาอย่างยั่งยืน โดยเน้นการลงทุนในโครงการที่สร้างมูลค่าเพิ่มให้กับชุมชนและสังคมในพื้นที่</li>
</ul>
<h3>วัตถุประสงค์</h3>

<ul>
<li>เพื่อสร้างแพลตฟอร์มที่ครบวงจรสำหรับการแลกเปลี่ยนข้อมูลและแนวปฏิบัติที่ดีที่สุดในด้านการค้าและการลงทุน</li>
<li>เพื่อสนับสนุนและพัฒนาศักยภาพของผู้ประกอบการ โดยเฉพาะ SMEs ให้สามารถเข้าถึงข้อมูลและทรัพยากรที่จำเป็นสำหรับการขยายธุรกิจ</li>
<li>เพื่อเก็บข้อมูลและวิเคราะห์แนวโน้มการค้าและการลงทุนเพื่อเสนอแนะนโยบายใหม่ที่เหมาะสมในการสนับสนุนและส่งเสริมกิจกรรมทางธุรกิจ</li>
<li>เพื่อสร้างเครือข่ายความร่วมมือระหว่างผู้มีส่วนได้ส่วนเสียในไทยและจีน ซึ่งรวมถึงผู้ประกอบการขนาดใหญ่ ขนาดกลาง และขนาดเล็กในหลายกลุ่มอุตสาหกรรม</li>
</ul>
<h3>ฟีเจอร์หลัก</h3>
<p><b>ศูนย์ข้อมูล</b> ให้บริการเอกสารวิจัย รายงานเชิงนโยบาย แนวทางปฏิบัติที่ดีที่สุด และข้อมูลเชิงลึกที่เกี่ยวข้องกับการค้าและการลงทุน</p>
<p><b>โอกาสในการสร้างเครือข่าย</b> จัดกิจกรรมการเชื่อมโยงธุรกิจเพื่อสร้างความสัมพันธ์ระหว่างนักลงทุนและผู้ประกอบการจากทั้งสองประเทศ</p>
<p><b>บริการให้คำปรึกษา</b> ให้บริการคำแนะนำและข้อมูลเชิงลึกเกี่ยวกับโอกาสการลงทุนและการค้าข้ามพรมแดน</p>
<p><b>การสัมมนาและอบรม</b> จัดกิจกรรมอบรมและสัมมนาออนไลน์และออฟไลน์เพื่อเพิ่มพูนความรู้และทักษะในการค้าและการลงทุน</p>
<p><b>แพลตฟอร์มดิจิทัล</b> มีระบบฐานข้อมูลการค้าและการลงทุนระหว่างประเทศเพื่อให้ผู้ใช้สามารถเข้าถึงข้อมูลที่จำเป็นได้อย่างรวดเร็วและสะดวก</p>


  </div>
</template>

<script>
export default {
  name: 'AboutPage' // เปลี่ยนชื่อเป็นหลายคำ
}
</script>
